import React, { useState } from "react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/solid";

const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed inset-x-0 top-0 z-40">
      <div className="mx-auto max-w-6xl px-4">
        <div className="mt-3 rounded-2xl border border-slate-200/70 bg-white/75 backdrop-blur-xl shadow-sm">
          <div className="flex items-center justify-between px-4 py-3 md:px-6">
            <a
              href="#home"
              className="font-poppins text-lg md:text-xl font-semibold tracking-tight text-slate-900"
            >
              <span className="text-[#4B5D3A]">Yerika</span>{" "}
              <span className="text-slate-800">Marley</span>
            </a>

            <nav className="hidden md:flex items-center gap-6 text-sm text-slate-700">
              <a
                href="#home"
                className="transition hover:text-[#3F5232]"
              >
                Inicio
              </a>
              <a
                href="#about"
                className="transition hover:text-[#3F5232]"
              >
                Perfil
              </a>
              <a
                href="#skills"
                className="transition hover:text-[#3F5232]"
              >
                Habilidades
              </a>
              <a
                href="#experience"
                className="transition hover:text-[#3F5232]"
              >
                Experiencia
              </a>
              <a
                href="#projects"
                className="transition hover:text-[#3F5232]"
              >
                Proyectos
              </a>
            </nav>

            <div className="flex items-center gap-2">
              <a
                href="#contact"
                className="hidden md:inline-flex items-center rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-800 shadow-sm transition hover:-translate-y-0.5 hover:shadow"
              >
                <span className="text-[#3F5232]">Contacto</span>
              </a>

              <button
                type="button"
                aria-label="Abrir menú"
                onClick={() => setOpen((v) => !v)}
                className="md:hidden inline-flex items-center justify-center rounded-xl border border-slate-200 bg-white p-2 shadow-sm transition hover:shadow"
              >
                {open ? (
                  <XMarkIcon className="h-5 w-5 text-[#3F5232]" />
                ) : (
                  <Bars3Icon className="h-5 w-5 text-[#3F5232]" />
                )}
              </button>
            </div>
          </div>

          {open && (
            <div className="md:hidden border-t border-slate-200/70 px-4 py-3">
              <nav className="flex flex-col gap-2 text-sm text-slate-700">
                <a
                  href="#home"
                  onClick={() => setOpen(false)}
                  className="rounded-xl px-3 py-2 hover:bg-slate-50 hover:text-[#3F5232]"
                >
                  Inicio
                </a>
                <a
                  href="#about"
                  onClick={() => setOpen(false)}
                  className="rounded-xl px-3 py-2 hover:bg-slate-50 hover:text-[#3F5232]"
                >
                  Perfil
                </a>
                <a
                  href="#skills"
                  onClick={() => setOpen(false)}
                  className="rounded-xl px-3 py-2 hover:bg-slate-50 hover:text-[#3F5232]"
                >
                  Habilidades
                </a>
                <a
                  href="#experience"
                  onClick={() => setOpen(false)}
                  className="rounded-xl px-3 py-2 hover:bg-slate-50 hover:text-[#3F5232]"
                >
                  Experiencia
                </a>
                <a
                  href="#projects"
                  onClick={() => setOpen(false)}
                  className="rounded-xl px-3 py-2 hover:bg-slate-50 hover:text-[#3F5232]"
                >
                  Proyectos
                </a>

                <a
                  href="#contact"
                  onClick={() => setOpen(false)}
                  className="mt-2 inline-flex items-center justify-center rounded-xl border border-slate-200 bg-white px-4 py-2 font-medium text-[#3F5232] shadow-sm"
                >
                  Contacto
                </a>
              </nav>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
